<template>
  <div id="app" class="wrapper">
    <router-view/>
    <TechnicalWarning v-if="false" />
  </div>
</template>
<script>
import TechnicalWarning from "@/components/general/TechnicalWarning.vue";
import { useMetrics } from '@/composables/use.metrics';
import dayjs from "dayjs";
import locale from "dayjs/locale/ru";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { computed, onBeforeUnmount, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'App',
  components: {
    TechnicalWarning
  },
  setup() {
    dayjs.extend(utc);
    dayjs.extend(timezone)
    dayjs.locale(locale);

    const store = useStore();
    const user = computed(() => store.getters.userData);
    const { eventType, hitType, setUuid, hit } = useMetrics();

    const route = useRoute();

    const showCurtain = computed(() => !route.path.startsWith('/guide-authorization') && !user.value);

    function hitRunGame() {
      hit(eventType.FIREWORK, hitType.RUN_GAME);
    }

    onMounted(() => {
      setUuid();
      document.addEventListener('hit-run-game', hitRunGame);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('hit-run-game', hitRunGame);
    })

    return {
      showCurtain,
    }
  }
}
</script>

<style>
.Vue-Toastification__container {
  z-index: 1000000000;
}
</style>